import { LazyLoad } from 'app/utils';

export const FeaturedShopSortPage = LazyLoad(() => import('./index'), (module) => module.FeaturedShopSortPage);
